import React, { useState, useEffect } from 'react';
import ModalWrapper from '../../components/ModalWrapper/ModalWrapper'
import InstantFeedback from '../../components/InstantFeedback/InstantFeedback.js'

const ModalFeedback = (props) => {
    const [_show, _setShow] = useState(props.mwShow)
    const [_instantFeedbackData, _setInstantFeedbackData] = useState(props.instantFeedbackData)

    const onClose = () => {
        _setShow(false)
        props.mwHandleOnClose && props.mwHandleOnClose()
    }

    useEffect(() => {
        _setShow(props.mwShow)
        _setInstantFeedbackData(props.instantFeedbackData)
    }, [props.mwShow, props.instantFeedbackData])

    return (
        <ModalWrapper
            mwShow={_show}
            mwClickOutsideToClose={props.mwClickOutsideToClose}
            mwHandleOnClose={onClose}
            mwComponentToRender={InstantFeedback}
            mwComponentToRenderProps={{data: _instantFeedbackData}}
        />
    )
}

export default ModalFeedback
